import { createContext, useContext } from 'react'

/**
 * React Flow edge id currently hovered by a palette drag
 * (sequenceDragEnter/Leave → hoveredSequenceId$) — the hovered edge highlights to
 * advertise the drop-to-splice gesture.
 */
export const DragOverEdgeContext = createContext<string | null>(null)

export function useIsEdgeDraggedOver(edgeId: string): boolean {
  return useContext(DragOverEdgeContext) === edgeId
}
